import ListagemLocaisEntrega from '@/modules/locais-entrega/ListagemLocaisEntrega.vue';
import LocaisEntregaCadastro from '@/modules/locais-entrega/cadastro/CadastroLocaisEntrega.vue';

export default [
  {
    path: 'locais-entrega',
    name: 'main.locais-entrega',
    components: {
      default: ListagemLocaisEntrega,
    },
  },
  {
    path: 'locais-entrega/cadastro',
    name: 'main.locais-entrega.cadastro',
    components: {
      default: LocaisEntregaCadastro,
    },
  },
  {
    path: 'locais-entrega/edicao/:id',
    name: 'main.locais-entrega.edicao',
    components: {
      default: LocaisEntregaCadastro,
    },
  },
];
